(function($, undefined) {

	// SHIM
	(function() {
		"use strict"

		var select = HTMLSelectElement.prototype;
		if (select.hasOwnProperty('selectedOptions')) return;

		Object.defineProperty(select, 'selectedOptions', {
			get: function() {
				return this.querySelectorAll(':checked')
			},
			enumerable: true,
			configurable: true,
		})
	})();

	function formatState(state) {
		if (! state.id) {
			return state.text;
		}

		var code = state.id.toLowerCase();

		return $state = $(
			'<span class="u-d-f u-ai-c">' +
			'	<span class="mr-5">' +
			'		<img class="select2-option__img" src="/img/flag/' + code + '.png" srcset="/img/flag/' + code + '.png, /img/flag/' + code + '@2x.png 2x" alt="' + code + '" />' +
			'	</span>' +
			'	' + state.text +
			'</span>'
		);
	}


	// Extension
	var lang = document.documentElement.lang;

	// Pokud nenajdeme potřebný jazyk, nastavíme fallback angličtinu
	try {
		$.fn.select2.amd.require('select2/i18n/' + lang);
	} catch (e) {
		lang = 'en';
	}

	var SELECT2_MAX_SHOWN_ITEM = 50;

	/* Data adaptér pro zobrazení max SELECT2_MAX_SHOWN_ITEM položek */
	$.fn.select2.amd.define('select2/data/customAdapter',[
			'select2/data/array',
			'select2/utils'
		],
		function (ArrayAdapter, Utils) {
			function CustomDataAdapter ($element, options) {
				if (! options.options.data) {
					options.options.data = [];
					$element.find('option').each(function () {
						options.options.data.push({
							id: this.value,
							text: this.text
						});
					});
				}

				$element.data('data', options.options.data);
				if (options.options.data && options.options.data.length > SELECT2_MAX_SHOWN_ITEM){
					options.options.data = null;
				}

				CustomDataAdapter.__super__.constructor.call(this, $element, options);
			}
			Utils.Extend(CustomDataAdapter, ArrayAdapter);

			CustomDataAdapter.prototype.current = function (callback) {
				var data = [];
				var selected = this.$element[0].selectedOptions;

				if (selected.length){
					for (var v = 0; v < selected.length; v++) {
						data.push({
							id: selected[v].value,
							text: selected[v].text
						});
					}
				}
				callback(data);
			};

			CustomDataAdapter.prototype.query = function (params, callback) {
				var data = [];
				var self = this;

				var $options = this.$element.children();

				if ($options.length <= SELECT2_MAX_SHOWN_ITEM || ($options.length > SELECT2_MAX_SHOWN_ITEM && $.trim(params.term) !== '')
				) {
					$options.each(function () {
						var $option = $(this);
						if (! $option.is('option') && ! $option.is('optgroup')) {
							return;
						}
						var option = self.item($option);
						var matches = self.matches(params, option);
						if (matches !== null) {
							data.push(matches);
						}
					});
				}

				// Seřadíme dle prefixu - přesná shoda na začátku má větší prioritu
				if (params.term) {
					data = prefixSorter(data, params.term);
				}

				callback({
					results: data.slice(0, SELECT2_MAX_SHOWN_ITEM) // Vrátíme pouze první SELECT2_MAX_SHOWN_ITEM výsledků
				});
			};

			return CustomDataAdapter;
		}
	);
	var customAdapter = $.fn.select2.amd.require('select2/data/customAdapter');

	var noResultsDefaultText = $.fn.select2.amd.require('select2/i18n/' + lang).noResults();

	var prefixSorter = function (results, term) {
		if (! results || results.length === 0) {
			return results;
		}

		// Find the open select2 search field and get its value
		if (term.length === 0) {
			return results;
		}

		return results.sort(function(a, b) {
			aHasPrefix = a.text.toLowerCase().indexOf(term) === 0;
			bHasPrefix = b.text.toLowerCase().indexOf(term) === 0;

			return bHasPrefix - aHasPrefix; // If one is prefixed, push to the top. Otherwise, no sorting.
		});
	}

	/**
	 * @author Radek Šerý
	 *
	 * Inicializace .js-select2 elementů. Napojeno na select2 knihovnu.
	 */
	$.nette.ext('select2', {
		init: function() {
			var snippetsExt = this.ext('snippets', true);
			var ext = this;

			snippetsExt.after(function($el) {
				ext.init.call(ext, $el);
			});

			this.init($(document));
		}
	}, {
		selector: '.js-select2 select',
		init: function($el) {

			$el
				.find(this.selector)
				.each(function() {
					var $select2 = $(this);

					/* Úprava noResults zprávy podle toho, zda byl zadaný nějaký řetězec */
					var translations = $.fn.select2.amd.require('select2/i18n/' + lang);
					var noResultsStartTyping = $select2.data('select2-start-typing');
					var id = $select2.attr('id');
					var $parent = $select2.parents('.js-select2').first();

					translations.noResults = function() {
						return (! event.target.value && noResultsStartTyping) ? noResultsStartTyping : noResultsDefaultText;
					}

					var datasource = $select2.data('datasource');

					var select2Options = {
						containerCssClass: 'inp-text',
						width: '100%',
						language: translations,
						selectOnClose: true
					};

					if(datasource) {
						select2Options.ajax = {
							url: datasource,
							delay: 300,
							dataType: 'json',
							processResults: function (data) {
							  return {
								results: data.items
							  };
							},
							cache: true
						}
						select2Options.minimumInputLength = 1;
					} else {
						select2Options.dataAdapter = customAdapter;
					}

					/* Pridani vlajek statu */
					if ($parent.hasClass('js-select2--flags')) {
						select2Options.templateResult = formatState;
						select2Options.templateSelection = formatState;
						select2Options.dropdownCssClass = "select2__option-flag";
					}

					/* Inicializace */
					$select2
						.select2(select2Options)
						.on('change.select2', function() {
							// Protože jQuery událost change se neodchytí v pdForms, vyvoláváme ručně validaci
							this.dispatchEvent(new CustomEvent('validate', { bubbles: true }));
						})
				})
		}
	});

})(jQuery);
